import { render, staticRenderFns } from "./PatentAnnualFeeReminderList.vue?vue&type=template&id=0226e210&"
import script from "./PatentAnnualFeeReminderList.vue?vue&type=script&lang=js&"
export * from "./PatentAnnualFeeReminderList.vue?vue&type=script&lang=js&"
import style0 from "./PatentAnnualFeeReminderList.vue?vue&type=style&index=0&id=0226e210&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports